import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  BoxSpg,
  CardSpg,
  getFieldError,
  GridContainer,
  GridItem,
  handleFormSubmission,
  InputFormField,
  shouldShowFieldError,
  SubmitFormButton,
  useAsyncCall,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { FormProvider } from "react-hook-form";
import { ForgottenUserDataDetails } from "../../../../types/forgottenUserDataTypes";
import { forgottenUserDataInitialValues } from "../../../../init/forgottenPasswordInitialValues";
import { toast } from "react-toastify";
import PageWrapper from "../../../components/common/layout/PageWrapper";
import { Alert, CardContent, Container, Typography } from "@mui/material";
import React from "react";
import { createBaseUserEmailValidationSchema } from "../../../../yup/schema/users/userValidationSchema";

const ForgottenUserData = ({ captchaAction, serviceFn, successMessage, pageTitle, submitMessage }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const { methods } = useReactHookForm<ForgottenUserDataDetails>({
    defaultValues: forgottenUserDataInitialValues,
    validationSchema: createBaseUserEmailValidationSchema,
  });

  const onSubmit = async (values) => {
    const token = await executeRecaptcha(captchaAction);
    const asyncRegistration: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: serviceFn(values, token),
      reactHooksForm: { methods },
      onSuccess: () => {
        methods.reset(forgottenUserDataInitialValues, { keepIsSubmitted: true, keepSubmitCount: true });
        toast.success(t(successMessage));
      },
    };
    asyncCall(asyncRegistration);
  };

  return (
    <PageWrapper title={t(pageTitle)}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <Container component={"main"} maxWidth={"xs"}>
            <BoxSpg
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <FormProvider {...methods}>
                <form onSubmit={handleFormSubmission({ methods, onSubmitFn: onSubmit, t })}>
                  {shouldShowFieldError("captchaToken", methods.formState, methods.getFieldState) ? (
                    <Alert severity={"error"}>{getFieldError("captchaToken", methods.getFieldState)}</Alert>
                  ) : null}
                  <GridContainer spacing={3}>
                    <GridItem sm={12} md={12}>
                      <InputFormField required={true} fieldName={"email"} labelCode={"l.person.email"} />
                    </GridItem>
                    <GridItem sm={12} md={12}>
                      <Typography align={"left"}>
                        <SubmitFormButton label={submitMessage} />
                      </Typography>
                    </GridItem>
                  </GridContainer>
                </form>
              </FormProvider>
            </BoxSpg>
          </Container>
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default ForgottenUserData;
